
import axios from 'axios'
import api from './api2.js'
import { Message } from 'element-ui';
import { Toast } from 'vant';
import router from '../../router'
axios.defaults.baseURL = "https://api.skatescustom.com/index";

var w=window.innerWidth
|| document.documentElement.clientWidth
|| document.body.clientWidth;
var web =  w > 678 ? false :true;

import global_variable from './global_variable'



export default function ajax (url = '', data = {}, type = 'GET' ) {


  return new Promise(function (resolve, reject) {
    let promise
    var token = api.getGhStorageItem("token");
    if (type === 'GET') {
      // 准备url query参数
      let dataStr = ''// 数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
   
      promise = axios.get(url, {headers: {token: token}})
    } else {
    
      promise = axios.post(url, data, {headers: {token: token}})
    }

    promise.then((response ) => {

      var status  =  response.data.status;


      if(status==200 || status==406 || status ==407  || status ==408 ){
          
          resolve(response.data);

      }else if(status==403){


          api.setGhStorageItem("url",window.location.href);

          router.replace("/login");
          

      }else{

          global_variable.showWranToast(response.data.msg);
        
          resolve(response.data);
      }


    }).catch(error => {
        reject(error)
    })


  })
}








// WEBPACK FOOTER //
// ./src/common/js/api.js